export const en = {
  generalError: {
    title: 'Something went wrong!',
    content:
      'It seems something is not working as intended at the moment. Please contact your Admin for further assistance',
  },
  ipNotAllowlisted: {
    title: 'Access Denied',
    content:
      'Your current network is not permitted to access this account. Please connect from an authorized network or contact your administrator for assistance.',
  },
  noLicenses: {
    title: 'No Licenses Available',
    content:
      'Your organization does not have any unused licenses available to create your account. Please contact your Simpli5<sup>&reg;</sup> administrator for assistance. We apologize for the inconvenience.',
  },
  linkedin: {
    generalError: {
      title: 'Something went wrong!',
      content:
        'It seems something is not working as intended at the moment. Please contact your Admin for further assistance',
    },
    noLicenses: {
      title: 'No Licenses Available',
      content:
        'Your organization does not have any unused licenses available to create your account. Please contact your Simpli5<sup>&reg;</sup> administrator for assistance. We apologize for the inconvenience.',
    },
  },
}

export const es = en
